
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class HSNTaxDetailsDialog extends Serenity.EntityDialog<HSNTaxDetailsRow, any> {
        protected getFormKey() { return HSNTaxDetailsForm.formKey; }
        protected getIdProperty() { return HSNTaxDetailsRow.idProperty; }
        protected getLocalTextPrefix() { return HSNTaxDetailsRow.localTextPrefix; }
        protected getService() { return HSNTaxDetailsService.baseUrl; }
        protected getDeletePermission() { return HSNTaxDetailsRow.deletePermission; }
        protected getInsertPermission() { return HSNTaxDetailsRow.insertPermission; }
        protected getUpdatePermission() { return HSNTaxDetailsRow.updatePermission; }

        protected form = new HSNTaxDetailsForm(this.idPrefix);

    }
}